import {
  AbstractType,
  Injectable,
  InjectionToken,
  Injector,
  Type,
} from '@angular/core';
import {
  concat,
  isEmpty,
  isFunction,
  isNil,
  join,
  reduce,
  upperFirst,
} from 'lodash';

import { ReplenishWorker } from './replenish-worker';
import { IReplenishBuilderParams } from './replenish.types';

@Injectable()
class ReplenishWorkerBuilder {
  public constructor(public injector: Injector) {}

  public inject<S>(
    token: Type<S> | InjectionToken<S> | AbstractType<S>,
    notFoundValue?: S,
  ): S {
    if (isFunction(this.injector.get)) {
      return this.injector?.get(token, notFoundValue);
    }

    return notFoundValue;
  }

  protected applyWorkerConfigs(
    worker: ReplenishWorker,
    configs?: IReplenishBuilderParams,
  ): ReplenishWorker {
    if (isNil(configs)) {
      return worker;
    }

    const nonCallableConfigs = reduce(
      configs,
      (allConfig, curConfigValue, curConfigKey) => {
        const workerConfigKey = `apply${upperFirst(curConfigKey)}`;

        if (isFunction(worker[workerConfigKey])) {
          worker[workerConfigKey](curConfigValue);

          return allConfig;
        }

        return concat(allConfig, workerConfigKey);
      },
      [],
    );

    if (!isEmpty(nonCallableConfigs)) {
      // eslint-disable-next-line no-console
      console.warn(
        `There is some config filed setting method not in the worker but you want to set it: ${join(nonCallableConfigs, ',')}`,
      );
    }

    return worker;
  }

  /**
   * build replenish worker
   *
   * @returns replenish worker
   */
  public build(params?: IReplenishBuilderParams): ReplenishWorker {
    let replenishWorker = new ReplenishWorker(this.injector);

    replenishWorker = this.applyWorkerConfigs(replenishWorker, params);

    return replenishWorker;
  }
}

export { ReplenishWorkerBuilder };
